export default __webpack_public_path__ + "static/media/xlsx.28ebf29d.svg";